import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class CarbonEmissionService {
  

  static getEmissions({ scope, category, db, period, businessUnitId}) {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_EMISSIONS
      .replace(scope ? "<scope>" : "?scope=<scope>", scope ?? '')
      .replace(category ? "<category>" : "&category=<category>", category ?? '')
      .replace(db ? "<db>" : "&db=<db>", db ?? '')
      .replace(period ? "<period>" : "&period=<period>", period ?? '')
      .replace(businessUnitId ? "<businessUnitId>" : "&businessUnitId=<businessUnitId>", businessUnitId ?? '')
    );
  }

  static getCategories(scope) {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_CATS
      .replace("<scope>", scope )
    );
  }
  static getGhgOpt() {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_GHG

    );
  }

  static getLevels({ scope, db, category, level, level1, level2, level3, level4, level5  }) {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_LEVELS
      .replace("<db>", db)
      .replace("<scope>", scope)
      .replace(category ? "<category>" : "?category=<category>", category ?? '')
      .replace(level ? "<level>" : "&level=<level>", level ?? '')
      .replace(level1 ? "<level1>" : "&level1=<level1>", level1 ?? '')
      .replace(level2 ? "<level2>" : "&level2=<level2>", level2 ?? '')
      .replace(level3 ? "<level3>" : "&level3=<level3>", level3 ?? '')
      .replace(level4 ? "<level4>" : "&level4=<level4>", level4 ?? '')
      .replace(level5 ? "<level5>" : "&level5=<level5>", level5 ?? '')
    );    
  }

  static getUOM({ scope, db, level1, level2, level3, level4, level5 }) {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_UOM
      .replace("<db>", db)
      .replace("<scope>", scope)
      .replace(level1 ? "<level1>" : "?level1=<level1>", level1 ?? '')
      .replace(level2 ? "<level2>" : "&level2=<level2>", level2 ?? '')
      .replace(level3 ? "<level3>" : "&level3=<level3>", level3 ?? '')
      .replace(level4 ? "<level4>" : "&level4=<level4>", level4 ?? '')
      .replace(level5 ? "<level5>" : "&level5=<level5>", level5 ?? '')
    );
  }

  static getLiveData(payload) {
    return HttpUtil.post(API_ROUTES.CARBON_EMISSION.GET_LIVE_DATA, payload);
  }

  static captureEmission(payload) {
    return HttpUtil.post(API_ROUTES.CARBON_EMISSION.CAPTURE, payload);
  }

  static getCategorizedEmissions({ db, period, ghgUnit, businessUnitIds }) {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_CATEGORIZED_EMISSIONS
      .replace("<db>", db)
      .replace("<period>", period)
      .replace("<ghgUnit>", ghgUnit)
      .replace(
        businessUnitIds?.length > 0 ? "<businessUnitId>" : "&businessUnitId=<businessUnitId>", 
        businessUnitIds?.length > 0 ? businessUnitIds?.toString() : ''
      )
    );
  }

  static getDB() {
    return HttpUtil.get(
      API_ROUTES.CARBON_EMISSION.GET_DB

    );
  }
}
